import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ValidationMessagesService } from './index.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private httpClient: HttpClient,
    public validationService: ValidationMessagesService,
    private router: Router) {
  }
  get(url: string): Observable<any> {
    return this.httpClient.get(`${environment.apiUrl}${url}`);
  }

  post(url: string, obj: any): Observable<any> {
    let payload: any = this.middleWare(obj)
    return this.httpClient.post(`${environment.apiUrl}${url}`, payload, { observe: 'response' });
  }

  postFormData(url: string, obj: any): Observable<any> {
    let payload: any = this.middleWare(obj);
    let formData: FormData = new FormData();
    for (let key of Object.keys(payload)) {
      formData.append(key, payload[key]);
    }
    return this.httpClient.post(`${environment.apiUrl}${url}`, formData);
  }

  postForConsentHtml(url: string, obj: any): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}${url}`, obj, { observe: 'response' });
  }

  middleWare(obj: any) {
    let payload: any = {}
    if (obj) {
      for (let x in obj) {
        payload[`${x}`] = this.validationService.regexForSecurity(obj[x]);
      }
    }
    return payload
  }
}
